import React from "react";
import PropTypes from "prop-types";

export default function PricingCheckbox(props) {
  const {className, id, text, onChange, checked} = props;
  const checkboxId = "pr-checkbox-" + (id || text);
  return (
    <div className={"pr-checkbox flex " + (className || "")}>
      <input type="checkbox" id={checkboxId} onChange={onChange} checked={checked} className="pr-checkbox__input"/>
      <label htmlFor={checkboxId} className="pr-checkbox__label font--12 bold">{text}</label>
    </div>
  )
}

PricingCheckbox.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  text: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
